import { createStore } from './create-store';
const store = createStore();

export { store };
export type Store = ReturnType<typeof store.getState>;
